




















































import { Component, Vue } from 'vue-property-decorator';
import PreLoader from '@/components/base/PreLoader.vue';
import Pagination from '@/components/base/Pagination.vue';
import { mdiEmailOutline, mdiEmailOpenOutline } from '@mdi/js';
import { RouteName } from '@/router';
import { NotificationDocModule } from '@/store/modules/notificationsDocuments';

// {
//   "id": "333",
//   "senderLastName": "Петров",
//   "senderName": "Федор",
//   "senderMiddleName": "Федорович",
//   "senderOrgName": "ООО Рога и копыта"
//   "trusteeLastName": "Цветков"
//   "trusteeMiddleName": "Савельевич"
//   "trusteeName": "Леонид"
//   "createDate": "11.03.2021 19:23:36",
//   "notarySentDate": "12.03.2021 19:23:36",
//   "isNew": false,
// }

@Component({
  components: {
    PreLoader,
    Pagination,
  },
  data: () => ({
    RouteName,
    mdiEmailOutline,
    mdiEmailOpenOutline,
  }),
})
export default class NotificationsDocumentsList extends Vue {
  loading: boolean = false;
  allNotificationsCount: number | null = 0;
  currentPage = 1;
  pageSize = 15;
  rawDocList: any = [];

  get docList() {
    return this.rawDocList.map((item: any) => {
      return {
        ...item,
        fullSender: !item.senderOrgName
          ? `${item.senderLastName} ${item.senderName} ${
              item.senderMiddleName ? item.senderMiddleName : ''
            }`
          : null,
        fullTrustee:
          item.trusteeLastName && item.trusteeName
            ? `${item.trusteeLastName} ${item.trusteeName} ${
                item.trusteeMiddleName ? item.trusteeMiddleName : ''
              }`
            : null,
        fullNotary:
          item.notaryLastName && item.notaryName
            ? `${item.notaryLastName} ${item.notaryName} ${
                item.notaryMiddleName ? item.notaryMiddleName : ''
              }`
            : null,
        description: item.isNew
          ? 'Нажмите для просмотра'
          : 'Документы просмотрены',
        iconName: item.isNew ? mdiEmailOutline : mdiEmailOpenOutline,
        iconColor: item.isNew ? 'primary' : 'greenLight',
        notarySentDateCustom: item?.notarySentDate?.split(' ')[0],
      };
    });
  }

  async mounted() {
    this.loading = true;
    NotificationDocModule.changePageSize(this.pageSize);
    await NotificationDocModule.getNotificationsDoc();
    this.rawDocList = NotificationDocModule.list;
    this.allNotificationsCount = NotificationDocModule.totalCount;
    this.loading = false;
  }

  async onChangePage(val: number) {
    this.loading = true;
    this.currentPage = val;
    await NotificationDocModule.changePageNumber(val - 1);
    await NotificationDocModule.getNotificationsDoc();
    this.rawDocList = NotificationDocModule.list;
    this.loading = false;
  }

  async onChangeLimit(val: number) {
    this.loading = true;
    this.currentPage = 1;
    await NotificationDocModule.changePageNumber(0);
    await NotificationDocModule.changePageSize(val);
    await NotificationDocModule.getNotificationsDoc();
    this.rawDocList = NotificationDocModule.list;
    this.allNotificationsCount = NotificationDocModule.totalCount;
    this.loading = false;
  }

  goDocNotification(id: string) {
    this.$router.push({
      name: RouteName.NOTIFICATIONS_DOCUMENTS_DETAIL,
      params: { id: id },
    });
  }
}
